"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var delta_stream_1 = __importStar(require("./delta-stream"));
var deltas_1 = require("./deltas");
var DeltaCollection = /** @class */ (function () {
    function DeltaCollection(connection) {
        this.path = '/delta';
        this.connection = connection;
    }
    DeltaCollection.prototype.latestCursor = function (callback) {
        var reqOpts = {
            method: 'POST',
            path: this.path + "/latest_cursor",
        };
        return this.connection
            .request(reqOpts)
            .then(function (response) {
            if (callback) {
                callback(null, response.cursor);
            }
            return Promise.resolve(response.cursor);
        })
            .catch(function (err) {
            if (callback) {
                callback(err, null);
            }
            return Promise.reject(err);
        });
    };
    DeltaCollection.prototype.since = function (cursor, params) {
        var _this = this;
        var queryParams = this.buildDeltaParams(params);
        return this.connection
            .request({
            method: 'GET',
            path: "" + this.path,
            qs: __assign({ cursor: cursor }, queryParams),
        })
            .then(function (response) {
            return Promise.resolve(new deltas_1.Deltas(_this.connection).fromJSON(response));
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    DeltaCollection.prototype.longPoll = function (cursor, timeout, params) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, stream;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParams = this.buildDeltaParams(params);
                        stream = new delta_stream_1.DeltaLongPoll(this.connection, cursor, timeout, queryParams);
                        return [4 /*yield*/, stream.open(true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, stream];
                }
            });
        });
    };
    DeltaCollection.prototype.startStream = function (cursor, params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var stream;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        stream = new delta_stream_1.default(this.connection, cursor, params);
                        return [4 /*yield*/, stream.open()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, stream];
                }
            });
        });
    };
    DeltaCollection.prototype.buildDeltaParams = function (params) {
        return __assign(__assign(__assign({}, ((params === null || params === void 0 ? void 0 : params.view) && { view: params.view })), ((params === null || params === void 0 ? void 0 : params.excludeTypes) && {
            exclude_types: params.excludeTypes.join(),
        })), ((params === null || params === void 0 ? void 0 : params.includeTypes) && { includeTypes: params.includeTypes.join() }));
    };
    return DeltaCollection;
}());
exports.default = DeltaCollection;
